import React, { Component } from 'react';
import GoogleLogin from './socialButtons/GoogleLogin';
import FacebookLoginStateless from './socialButtons/FacebookLoginStateless';
import { Link } from "react-router-dom";

import { getAPIData, createLoginSession, getL, setL, clearL, isLoggedIn } from './../../util/lib';
import { showNotification } from './../../util/notification';
import PhoneNumber from './ui/PhoneNumber';
import PropTypes from 'prop-types';
import MessageWidget from './MessageWidget';

import { authRedirection, createUserSession, preserveUserData } from '../../util/authUtils';

import { ga4Event } from './trackers/GA4Tracker';
import RecaptchaFactory from './recaptcha/RecaptchaFactory';

import './../scss/LoginForm.scss';
import { isOtherTechEnabledSibbo, isSocialLoginAllowed } from '../../util/gdprUtils';
import { debugLog } from '../../util/logUtils';
import { GDPRBridgeHOC } from './GDPR/LegacySupport/GDPRBridgeHOC';
class LoginForm extends Component {
	constructor(props) {
		super(props);
		const wProps = this.props || {},
			wData = wProps.widgets[0] || {},
			meta = wData.meta || {},
			enableRecaptcha = meta.enableRecaptcha || false,
			forgotMeta = meta.forgot || {},
			enableRecaptchaFP = forgotMeta.enableRecaptcha || false,
			data = wData.data || {},
			recaptchaObj = data.recaptcha || {},
			recaptchaSiteKey = recaptchaObj.publicKey || '',
			recaptchaVersion = recaptchaObj.version || 'v3',
			canSendOtpByPhoneYN = (forgotMeta.hasOwnProperty('canSendOtpByPhoneYN') ? forgotMeta.canSendOtpByPhoneYN : true),
			canSendOtpByEmailYN = (forgotMeta.hasOwnProperty('canSendOtpByEmailYN') ? forgotMeta.canSendOtpByEmailYN : true);
		//	debugLog(this.props)

		this.state = {
			enableRecaptcha,
			enableRecaptchaFP,
			recaptchaSiteKey,
			recaptchaVersion,
			recaptchaToken: '',
			email: '',
			phone: '',
			otp: '',
			password: '',
			confirmpassword: '',
			errorMessage: null,
			isforgotPassword: null,
			forgotPasswordErrorMsg: null,

			country_list: props.data.data.forgot.countryList,
			dial_code: null,

			ForgotPasswordType: ((canSendOtpByPhoneYN && !canSendOtpByEmailYN) ? 'phone' : 'email'),

			sendOTPflow: true,
			verifyOTPflow: null,

			passwordSetFlow: null,

			restrictValueChange: null,
		};

		const loggedin = isLoggedIn();

		if (loggedin && this.props.history) {
			this.props.history.go(-1); // TODO ASYNC
		}
		this.handleEmailChange = this.handleEmailChange.bind(this);
		this.handlePhoneChange = this.handlePhoneChange.bind(this);
		this.handlePasswordChange = this.handlePasswordChange.bind(this);
		this.handleConfirmPasswordChange = this.handleConfirmPasswordChange.bind(this);
		this.handleOTPChange = this.handleOTPChange.bind(this);
		this.handleForgotPassword = this.handleForgotPassword.bind(this);
		this.handleForgotPasswordSubmit = this.handleForgotPasswordSubmit.bind(this);


		this.handleVerifyOTP = this.handleVerifyOTP.bind(this);

		this.setForgotPasswordType = this.setForgotPasswordType.bind(this);

		this.handlesetPassword = this.handlesetPassword.bind(this);

		this.handleSubmit = this.handleSubmit.bind(this);
		// createLoginSession = createLoginSession.bind(this);
		this.handleDialcodeChange = this.handleDialcodeChange.bind(this);
	}

	static propTypes = {
		data: PropTypes.shape({
			data: PropTypes.shape({
				actionURL: PropTypes.shape({
					type: PropTypes.string,
					url: PropTypes.string
				}),
				forgot: PropTypes.shape({
					actionURL: PropTypes.shape({
						type: PropTypes.string,
						url: PropTypes.string,
					}),
					countryList: PropTypes.arrayOf(
						PropTypes.shape({
							active: PropTypes.bool,
							country_name: PropTypes.string,
							dial_code: PropTypes.string,
						}),
					),
					updatePasswordURL: PropTypes.shape({
						type: PropTypes.string,
						url: PropTypes.string,
					}),
					verifyOTPURL: PropTypes.shape({
						type: PropTypes.string,
						url: PropTypes.string
					}),
				}),
				forgotPasswordPageURL: PropTypes.shape({
					host: PropTypes.string,
					path: PropTypes.string,
					type: PropTypes.string,
					url: PropTypes.string,
				}),
				infoText: PropTypes.string,
				labels: PropTypes.shape({
					OTP: PropTypes.string,
					confirmPassword: PropTypes.string,
					createAccount: PropTypes.string,
					dontHaveAccount: PropTypes.string,
					email: PropTypes.string,
					emailAddress: PropTypes.string,
					forgotPassword: PropTypes.string,
					goBack: PropTypes.string,
					login: PropTypes.string,
					password: PropTypes.string,
					phone: PropTypes.string,
					phoneNumber: PropTypes.string,
					rememberMe: PropTypes.string,
					setPassword: PropTypes.string,
					verifyOTP: PropTypes.string
				}),
				registerPageURL: PropTypes.shape({
					host: PropTypes.string,
					path: PropTypes.string,
					type: PropTypes.string,
					url: PropTypes.string,
				}),
				socialLogin: PropTypes.shape({
					type: PropTypes.string,
					url: PropTypes.string,
				}),
			}),
			layout: PropTypes.number,
			meta: PropTypes.object,
			type: PropTypes.string,
		}),
		history: PropTypes.shape({
			action: PropTypes.string,
			length: PropTypes.number,
			location: PropTypes.shape({
				hash: PropTypes.string,
				key: PropTypes.string,
				pathname: PropTypes.string,
				search: PropTypes.string,
			}),
		}),
		id: PropTypes.string,
		location: PropTypes.shape({
			hash: PropTypes.string,
			key: PropTypes.string,
			pathname: PropTypes.string,
			search: PropTypes.string,
		}),
		match: PropTypes.shape({
			isExact: PropTypes.bool,
			params: PropTypes.object,
			path: PropTypes.string,
			url: PropTypes.string,
			routing_api: PropTypes.string,
		}),
	}

	handleDialcodeChange(value) {
		this.setState({ dial_code: value });
	}

	handleEmailChange(event) {
		this.setState({ email: event.target.value });
	}

	handleOTPChange(event) {
		this.setState({ otp: event.target.value });
	}

	handlePhoneChange(value) {
		this.setState({ phone: value });
	}

	handlePasswordChange(event) {
		this.setState({ password: event.target.value });
	}
	handleConfirmPasswordChange(event) {
		this.setState({ confirmpassword: event.target.value });
	}

	setForgotPasswordType(event) {
		this.setState({ ForgotPasswordType: event.target.value });
	}

	handleForgotPassword(event) {
		this.setState({ isforgotPassword: true });
	}

	handleForgotPasswordGoBack = (event) => {
		this.setState({
			isforgotPassword: false,
			sendOTPflow: true,
			verifyOTPflow: false,
			restrictValueChange: false,
		});
	}


	handleVerifyOTP(event) {

		var data = {
			verification_code: this.state.otp
		};

		if (this.state.ForgotPasswordType === 'email') {
			data.email = this.state.email
		} else if (this.state.ForgotPasswordType === 'phone') {
			data.phone = this.state.phone;
			data.dial_code = this.state.dial_code;
		}

		getAPIData(this.props.data.data.forgot.verifyOTPURL.url, data, (response) => {
			if (response.type === 'Success') {
				this.setState({
					verifyOTPflow: false,
					passwordSetFlow: true,
					verification_id: response.data.verification_id
				});
			} else if (response.type === 'Error') {
				showNotification({ text: response.data.message });
				// this.setState({
				// 	forgotPasswordErrorMsg: response.data.message,		
				// })
			}
		})
	}

	handlesetPassword(event) {

		const wProps = this.props || {},
			wData = wProps.widgets[0] || {},
			{ data: passwordData = {} } = wData || {},
			{ labels: passwordLabels = {} } = passwordData,
			{ password_mismatch = 'Passwords does not match',
				password_required = 'Password is required' } = passwordLabels;
		var error = false;

		if (this.state.password !== this.state.confirmpassword) {
			error = password_mismatch;
		}

		if (this.state.password === '' || this.state.confirmpassword === '') {
			error = password_required;
		}

		if (error) {
			showNotification({ text: error });
			// this.setState({
			// 	forgotPasswordErrorMsg: error
			// });
			return;
		}


		var data = {
			verification_code: this.state.otp,
			verification_id: this.state.verification_id,
			password: this.state.password,
			captcha_token: this.state.recaptchaToken,
		};

		if (this.state.ForgotPasswordType === 'email') {
			data.email = this.state.email
		} else if (this.state.ForgotPasswordType === 'phone') {
			data.phone = this.state.phone;
			data.dial_code = this.state.dial_code;
		}

		getAPIData(this.props.data.data.forgot.updatePasswordURL.url, data, (response) => {

			if (response.type === 'Success') {
				const { data: responseData = {} } = response,
					{ message: passworChangeMessage = 'Your Password has been reset!' } = responseData;
				this.setState({
					passwordSetFlow: false,
					isforgotPassword: false,
					verification_id: null,
					otp: null,
					sendOTPflow: true,
					password: '',
					confirmpassword: '',
					restrictValueChange: false,
				});
				showNotification({ text: passworChangeMessage, type: 'success' });
			} else if (response.type === 'Error') {
				showNotification({ text: response.data.message });
				// this.setState({
				// 	forgotPasswordErrorMsg: response.data.message,		
				// })
			}
		})
	}

	handlesetPasswordV2 = (event) => {
		event.preventDefault();
		const { recaptchaVersion = 'v3', recaptchaSiteKey = '', enableRecaptcha = '' } = this.state || {};
		if (window.grecaptcha && enableRecaptcha && recaptchaVersion && recaptchaSiteKey) {
			window.grecaptcha.ready(() => {
				debugLog("recaptcha ready");
				window.grecaptcha.execute(recaptchaSiteKey, { action: 'submit' }).then((token) => {
					debugLog('recaptcha output', token);
					this.setState({
						recaptchaToken: token
					}, () => this.handlesetPassword(event));
				});
			});
		} else {
			debugLog('recaptcha not loaded');
			showNotification({ text: 'Somthing went wrong please try again.' });
		}
	}
	handleForgotPasswordSubmit(event) {


		var data = {};

		if (this.state.ForgotPasswordType === 'email') {
			data.email = this.state.email
		} else if (this.state.ForgotPasswordType === 'phone') {
			data.phone = this.state.phone;
			data.dial_code = this.state.dial_code;
		}

		getAPIData(this.props.data.data.forgot.actionURL.url, data, (response) => {
			if (response.type === 'Success') {
				this.setState({
					sendOTPflow: false,
					verifyOTPflow: true,
					restrictValueChange: true
				});
				showNotification({ text: response.data.message, type: 'success' });
			} else if (response.type === 'Error') {
				showNotification({ text: response.data.message });
				// this.setState({
				// 	forgotPasswordErrorMsg: response.data.message,		
				// })
			}
		})

	}

	handleSubmitV2 = (event) => {
		event.preventDefault();
		const { recaptchaVersion = 'v3', recaptchaSiteKey = '', enableRecaptcha = '' } = this.state || {};
		if (window.grecaptcha && enableRecaptcha && recaptchaVersion && recaptchaSiteKey) {
			window.grecaptcha.ready(() => {
				debugLog("recaptcha ready");
				window.grecaptcha.execute(recaptchaSiteKey, { action: 'submit' }).then((token) => {
					debugLog('recaptcha output', token);
					this.setState({
						recaptchaToken: token
					}, () => this.handleSubmit(event));
				});
			});
		} else {
			debugLog('recaptcha not loaded');
			showNotification({ text: 'Somthing went wrong please try again.' });
		}
	}
	handleSubmit(event) {
		event.preventDefault();

		const page_url = this.props.data.data.actionURL.url,
			{ data: wData = {} } = this.props,
			{ data = {} } = wData,
			{ labels = {} } = data,
			{ gdprEnabled, tcData } = this.props,
			{ publisher = {} } = tcData,
			{ consents = {} } = publisher;
		debugLog('lffrom:', wData);
		debugLog('lffrom:', data);
		debugLog('lffrom:', labels);
		debugLog('lffrom:', labels.gdprMsg);
		if (gdprEnabled) {
			if (!consents['1']) {
				showNotification({ text: labels.gdprMsg });
				return;
			}
		}
		getAPIData(page_url, {
			email: this.state.email,
			password: this.state.password,
			captcha_token: this.state.recaptchaToken
			// user_id: 6138
		}, (response) => {
			// var response = parseAPIResponse(result);

			if (response.type === 'Error') {
				showNotification({ text: response.data.message });
				// this.setState({
				// 	errorMessage: response.data.message
				// });
			}

			if (response.type === 'Success') {
				const respData = response.data || {};
				const lastVideoLocation = getL('lastVideoLocation');

				if (lastVideoLocation) {
					setL('destination_page_path', lastVideoLocation);
					clearL('payment_plan_id');
				}

				ga4Event('login', { method: 'Ventuno' });
				if (respData.token && respData.refresh_token) {
					const {
						token = "",
						refresh_token = "",
						next_page_url = {} } = respData;
					if (createUserSession('localstore', {
						token,
						refreshToken: refresh_token
					})) {
						preserveUserData(respData.user);
						authRedirection(next_page_url);
					}
				} else {
					createLoginSession(respData.user || {}, respData.next_page_url || {});
				}
			}

		});
		event.preventDefault();
	}
	onGoogleAuth = (gData = {}) => {
		const type = "google",
			user = gData.user || {},
			email = user.email || "",
			name = user.displayName || "",
			picture = user.photoURL || "",
			google_id = user.uid || "",
			wData = this.props.data || {},
			data = wData.data || {},
			socialLoginV2 = data.socialLoginV2 || {},
			socialLoginData = socialLoginV2.data || {},
			googleLogin = socialLoginData.action_gmail || {},
			googleLoginData = googleLogin.data || {},
			googleLoginurlObj = googleLoginData.url || {},
			actionUrl = googleLoginurlObj.url || "",
			labels = data.labels || {},
			googleLoginError = labels.google_not_connect || 'Unable to connect to Google account!.';
			console.log('log>>>>:',data, labels);

		debugLog('success');

		if (gData) {
			//invoke social login api
			const
				postData = {
					type: "google",
					data: JSON.stringify({
						type,
						name,
						email,
						picture,
						userId: google_id
					}),
				};
			debugLog("actionmmmmm:", wData);
			if (actionUrl) {
				debugLog("gl ac:", socialLoginV2);
				getAPIData(actionUrl, postData, (response) => {
					if (response.type === 'Success') {
						const respData = response.data || {},
							// user = respData.user || {},
							lastVideoLocation = getL('lastVideoLocation');

						if (lastVideoLocation) {
							setL('destination_page_path', lastVideoLocation);
							clearL('payment_plan_id');
						}

						debugLog('success');
						ga4Event('login', { method: 'Google' });
						if (respData.token && respData.refresh_token) {
							const {
								token = "",
								refresh_token = "",
								next_page_url = {} } = respData;
							if (createUserSession('localstore', {
								token,
								refreshToken: refresh_token
							})) {
								preserveUserData(respData.user);
								authRedirection(next_page_url);
							}
						} else {
							createLoginSession(respData.user || {}, respData.next_page_url || {});
						}
					} else {
						const rdata = response.data || {};
						showNotification({ text: rdata.message });
					}
				});
			} else {
				showNotification({ text: googleLoginError });
			}

		} else {
			showNotification({ text: googleLoginError });
		}
	}

	onFacebookAuth = (fData = {}) => {
		const type = "facebook",
			email = fData.email || "",
			name = fData.name || "",
			picture = fData.picture || {},
			pictureData = picture.data || {},
			pictureUrl = pictureData.url || "",
			facebook_id = fData.id || "",
			wData = this.props.data || {},
			data = wData.data || {},
			socialLoginV2 = data.socialLoginV2 || {},
			socialLoginData = socialLoginV2.data || {},
			facebookLogin = socialLoginData.action_facebook || {},
			facebookLoginData = facebookLogin.data || {},
			facebookLoginurlObj = facebookLoginData.url || {},
			actionUrl = facebookLoginurlObj.url || "",
			labels = data.labels || {},
			facebookLoginError = labels.facebook_not_connect || 'Unable to connect to Facebook account.';

		if (fData) {
			//invoke social login api
			const
				postData = {
					type,
					data: JSON.stringify({
						name,
						email,
						picture: pictureUrl,
						fbId: facebook_id
					}),
				};

			getAPIData(actionUrl, postData, (response) => {
				if (response.type === 'Success') {
					const respData = response.data || {},
						// user = respData.user || {}, 
						lastVideoLocation = getL('lastVideoLocation');

					if (lastVideoLocation) {
						setL('destination_page_path', lastVideoLocation);
						clearL('payment_plan_id');
					}

					ga4Event('login', { method: 'Facebook' });
					if (respData.token && respData.refresh_token) {
						const {
							token = "",
							refresh_token = "",
							next_page_url = {} } = respData;
						if (createUserSession('localstore', {
							token,
							refreshToken: refresh_token
						})) {
							preserveUserData(respData.user);
							authRedirection(next_page_url);
						}
					} else {
						createLoginSession(respData.user || {}, respData.next_page_url || {});
					}
				} else {
					const rdata = response.data || {};
					showNotification({ text: rdata.message });
				}
			});
		} else {
			showNotification({ text: facebookLoginError });
		}
	}

	render() {
		const wData = this.props.data || {},
			data = wData.data || {},
			meta = wData.meta || {},
			forgot = meta.forgot || {},
			SEND_OTP_LABEL = "Send OTP",
			labels = data.labels || {},
			sendOTPLabel = labels.sendOTP || SEND_OTP_LABEL,
			socialLoginV2 = data.socialLoginV2 || {},
			socialLoginV2Data = socialLoginV2.data || {},
			socialLoginTitle = socialLoginV2Data.title || '',
			socialLoginDescription = socialLoginV2Data.description || '',
			socialLoginV2Meta = meta.socialLoginV2 || {},
			socialLoginTitleMeta = socialLoginV2Meta.title || '',
			socialLoginDescriptionMeta = socialLoginV2Meta.description || '',
			googleLogin = socialLoginV2Data.action_gmail || {},
			googleLoginData = googleLogin.data || {},
			facebookLogin = socialLoginV2Data.action_facebook || {},
			facebookLoginData = facebookLogin.data || {},
			gooleLoginMeta = socialLoginV2Meta.action_gmail || {},
			facebookLoginMeta = socialLoginV2Meta.action_facebook || {},
			message = data.message || {},
			// messageMeta = meta.message || {},
			{ enableRecaptcha = false } = this.state,
			{ tcData } = this.props;

		// debugLog(this.props.data);
		debugLog("login frm:", this.props);
		const id = this.props.id
		// const title = data.title;
		// const action = data.actionURL.url;
		// const forgot_password_url = (data.forgotPasswordURL && data.forgotPasswordURL.url) || action;
		const create_account_url = data.registerPageURL && data.registerPageURL.path;
		//Localization
		var label_phoneNumber = data.labels.phoneNumber || "NONE" || 'Phone number';

		var label_emailAddress = data.labels.emailAddress || "NONE" || 'Email Address';
		var label_rememberMe = data.labels.rememberMe || "NONE" || 'Remember me';
		var label_forgotPassword = data.labels.forgotPassword || "NONE" || 'Forogt password ?';
		var label_login = data.labels.login || "NONE" || 'LOGIN';
		var label_dontHaveAccount = data.labels.dontHaveAccount || "NONE" || 'Don\'t have an account?';
		var label_createAccount = data.labels.createAccount || "NONE" || 'Create Account';
		var label_goBack = data.labels.goBack || "NONE" || 'Go Back';
		var label_email = data.labels.email || "NONE" || 'Email';
		var label_phone = data.labels.phone || "NONE" || 'Phone';
		var label_OTP = data.labels.OTP || "NONE" || 'OTP';
		var label_password = data.labels.password || "NONE" || 'password';
		var label_confirmPassword = data.labels.confirmPassword || "NONE" || 'Confirm Password';
		var label_setPassword = data.labels.setPassword || "NONE" || 'Set Password';
		var label_verifyOTP = data.labels.verifyOTP || "NONE" || 'Verify OTP';
		var label_resendOTP = data.labels.resendOTP || "NONE" || 'Resend OTP';
		debugLog("asdf:", socialLoginDescriptionMeta);

		debugLog("lf isa:", isSocialLoginAllowed(tcData));
		return (
			<div id={id} className="v-widget login-form container">
				{<MessageWidget data={message} />}
				<form onSubmit={enableRecaptcha ? this.handleSubmitV2 : this.handleSubmit}>
					{enableRecaptcha && <RecaptchaFactory sitekey={this.state.recaptchaSiteKey} version={this.state.recaptchaVersion} />}
					{this.state.errorMessage &&
						<div className='widget-title'>
							<h2>{this.state.errorMessage}</h2>
						</div>
					}
					{!this.state.isforgotPassword &&
						<React.Fragment>
							<div className="form-group row">
								<label htmlFor="inputEmail" className="sr-only">{label_emailAddress}</label>
								<input type="text" id="inputEmail" name='email' className="vt-input form-control col" placeholder={label_emailAddress} required autoFocus onChange={this.handleEmailChange} />
							</div>
							<div className="form-group row">
								<label htmlFor="inputPassword" className="sr-only">{label_password}</label>
								<input type="password" id="inputPassword" name='password' className="vt-input form-control col" placeholder={label_password} required onChange={this.handlePasswordChange} />
							</div>
							<div className="form-group row">
								<label className="col-6">
									<input type="checkbox" value="remember-me" /> {label_rememberMe}
								</label>
								<label className="col-6 text-accent text-right cursor-pointer" onClick={this.handleForgotPassword}>
									{label_forgotPassword}
								</label>
							</div>
							<div className="form-group row">
								<button className="btn btn-lg vt-btn vt-btn-primary btn-inline-block" type="submit">{label_login}</button>
							</div>
							<div className="form-group row">
								<label className="col-12 text-secondary">
									{`${label_dontHaveAccount} `}
									<span className='text-accent'>
										<Link to={create_account_url}>{label_createAccount}</Link>
									</span>
								</label>
							</div>
						</React.Fragment>
					}
					{this.state.isforgotPassword &&
						<React.Fragment>

							<div className="form-group row">
								<label className="text-accent text-right cursor-pointer" onClick={this.handleForgotPasswordGoBack}>
									{label_goBack}
								</label>
							</div>
							<div className="form-group row">
								{!forgot.canSendOtpByPhoneYN ? '' : <div className="form-check m-1">
									<input
										className="form-check-input"
										onChange={this.setForgotPasswordType}
										name='forgotpassword-toggle-chk'
										type='radio'
										checked={this.state.ForgotPasswordType === 'phone' ? true : false}
										value='phone'
										disabled={this.state.restrictValueChange ? true : false}
										id='forgotpassword-type-toggle-phone'
									/>
									<label
										className="form-check-label filter-item"
										htmlFor='forgotpassword-type-toggle-phone'
									>
										{label_phone}
									</label>
								</div>}

								{!forgot.canSendOtpByEmailYN ? '' : <div className="form-check m-1">
									<input
										className="form-check-input"
										onChange={this.setForgotPasswordType}
										name='forgotpassword-toggle-chk'
										type='radio'
										checked={this.state.ForgotPasswordType === 'email' ? true : false}
										value='email'
										disabled={this.state.restrictValueChange ? true : false}
										id='forgotpassword-type-toggle-email'
									/>
									<label
										className="form-check-label filter-item"
										htmlFor='forgotpassword-type-toggle-email'
									>
										{label_email}
									</label>
								</div>}
							</div>

							{this.state.ForgotPasswordType === 'phone' &&
								<div className="form-group row">
									<PhoneNumber
										countryList={this.state.country_list}
										onSelectChange={this.handleDialcodeChange}
										onPhoneChange={this.handlePhoneChange}
										label={label_phoneNumber}
									/>
									{/*
									<label htmlFor="inputPhone-frgt" className="sr-only">Phone</label>
									<input type="text" id="inputPhone-frgt" disabled={this.state.restrictValueChange ? true : false} name='phone' value={this.state.phone} className="vt-input form-control col" placeholder="Phone" onChange={this.handlePhoneChange}/>
									*/}
								</div>
							}
							{this.state.ForgotPasswordType === 'email' &&
								<div className="form-group row">
									<label htmlFor="inputEmail" className="sr-only">{label_emailAddress}</label>
									<input type="text" id="inputEmail" disabled={this.state.restrictValueChange ? true : false} name='email' value={this.state.email} className="vt-input form-control col" placeholder={label_emailAddress} onChange={this.handleEmailChange} />
								</div>
							}
							{this.state.sendOTPflow &&
								<div className="form-group row">
									<button className="btn btn-lg vt-btn vt-btn-primary btn-inline-block" type="button" onClick={this.handleForgotPasswordSubmit}>{sendOTPLabel}</button>
								</div>
							}
							{this.state.verifyOTPflow &&
								<React.Fragment>
									<div className="form-group row">
										<label htmlFor="inputOTP" className="sr-only">{label_OTP}</label>
										<input type="text" id="inputOTP" name='otp' value={this.state.otp} className="vt-input form-control col" placeholder={label_OTP} onChange={this.handleOTPChange} />
									</div>
									{forgot.canShowResendOTP && <div className="form-group row">
										<label className="vt-btn-link" onClick={this.handleForgotPasswordSubmit}>{label_resendOTP}</label>
									</div>}
									<div className="form-group row">
										<button className="btn btn-lg vt-btn vt-btn-primary btn-inline-block" type="button" onClick={this.handleVerifyOTP}>{label_verifyOTP}</button>
									</div>
								</React.Fragment>
							}

							{this.state.passwordSetFlow &&
								<React.Fragment>
									<div className="form-group row">
										<label htmlFor="inputPassword" className="sr-only">{label_password}</label>
										<input type="password" id="inputPassword" name='password' value={this.state.password} className="vt-input form-control col" placeholder={label_password} onChange={this.handlePasswordChange} />
									</div>
									<div className="form-group row">
										<label htmlFor="inputConfirmPassword" className="sr-only">{label_confirmPassword}</label>
										<input type="password" id="inputConfirmPassword" name='confirm-password' value={this.state.confirmpassword} className="vt-input form-control col" placeholder={label_confirmPassword} onChange={this.handleConfirmPasswordChange} />
									</div>
									<div className="form-group row">
										<button className="btn btn-lg vt-btn vt-btn-primary btn-inline-block" type="button"
											onClick={enableRecaptcha ? this.handlesetPasswordV2 : this.handlesetPassword}>
											{label_setPassword}</button>
									</div>
								</React.Fragment>
							}
							{this.state.forgotPasswordErrorMsg &&
								<div className="form-group row text-center">
									<span className='text-danger col'>{this.state.forgotPasswordErrorMsg}</span>
								</div>
							}
						</React.Fragment>

					}
					{socialLoginV2Meta.canShow && isSocialLoginAllowed(tcData) && <>
						{socialLoginTitleMeta.canShow && <h2>{socialLoginTitle}</h2>}
						{socialLoginDescriptionMeta.canShow && <p>{socialLoginDescription}</p>}
						{gooleLoginMeta.canShow && isOtherTechEnabledSibbo("google") && <div className="form-group row">
							<GoogleLogin data={googleLoginData} onAuth={this.onGoogleAuth} />
						</div>}
						{facebookLoginMeta.canShow && <div className="form-group row">
							<FacebookLoginStateless data={facebookLoginData} onAuth={this.onFacebookAuth} />
						</div>}
					</>}
				</form>
			</div>
		);
	}
}

export default GDPRBridgeHOC(LoginForm);
